import React, { useMemo } from "react";
import { View } from "react-native";
import { useI18n } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { ReturnQuestionType } from "../../../../../../../projection/returnQuestion/returnQuestion.constants";
import { DOMAIN } from "../../../../../i18n/i18n";
import { ReturnQuestionItem } from "../ReturnQuestionItem";
import { style as hostLegacyRadioGroupReturnQuestionItemStyle } from "./HostLegacyRadioGroupReturnQuestionItem.style";

const HostLegacyRadioGroupReturnQuestionItem: ReturnQuestionItem<ReturnQuestionType.HOST_SELECT> = ({
  returnQuestion,
  children,
  testID,
}) => {
  const { formatMessage } = useI18n({ domain: DOMAIN });
  const placeholderText = useMemo(
    () => (returnQuestion.metadata.placeholder ? formatMessage({ id: returnQuestion.metadata.placeholder }) : ""),
    [formatMessage, returnQuestion.metadata.placeholder],
  );

  const style = useMemo(() => hostLegacyRadioGroupReturnQuestionItemStyle(), []);

  return (
    <>
      <View style={style.wrapper} testID={testID}>
        <Text level={3} style={style.title} variant="action">
          {placeholderText}
        </Text>
        {children}
      </View>
    </>
  );
};

export { HostLegacyRadioGroupReturnQuestionItem };
